import { useIntersectionObserver } from 'usehooks-ts'

import { type RxPdpAppPlacement } from './rxPdpAppRedemptionLinks'
import { useRxPdpAppRedemptionTracking } from './useRxPdpAppRedemptionTracking'

export const useRxPdpAppImpression = ({
  action,
  placement,
}: {
  action: 'app_cta_impression' | 'qr_impression'
  placement: RxPdpAppPlacement
}): ((node?: Element | null) => void) | undefined => {
  const tracking = useRxPdpAppRedemptionTracking()
  const { ref } = useIntersectionObserver({
    freezeOnceVisible: true,
    onChange: (visible) => {
      if (!visible || !tracking) {
        return
      }

      tracking.track({ action, placement })
    },
  })

  return tracking ? ref : undefined
}
